import React from 'react';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { buildKey } from '@yme/utils/common';
import { OverflowMenuStyled, UlMenu, ItemMenu, ItemTitle } from './styled';
export function OverflowMenu(props) {
    const { items = [], children, isRightToLeft, onClickMenu } = props;
    if (children) {
        // TODO: Need adjust this functionality
        React.createElement(OverflowMenuStyled, { isRightToLeft: isRightToLeft }, children);
    }
    return (React.createElement(OverflowMenuStyled, { "data-class-overflow-menu": true, isRightToLeft: isRightToLeft, onClick: onClickMenu },
        React.createElement(UlMenu, null, items.map(({ callback, value, iconType }, index) => (React.createElement(ItemMenu, { key: buildKey(value, index), onClick: callback, isRightToLeft: isRightToLeft },
            React.createElement(ItemTitle, null, value),
            React.createElement(SVGIcon, { type: iconType })))))));
}
OverflowMenu.displayName = 'OverflowMenu_Component';
